'use client'

import {
	Avatar,
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Typography
} from '@mui/material'
import { red } from '@mui/material/colors'
import { NavLink } from 'react-router'

export default function PlanCard({ plan, actions, color = red[500] }: any) {
	const titleString = `${plan?.profile?.name}'s Plan`

	return (
		<Card>
			{plan?.profile?.name && (
				<CardHeader
					title={titleString}
					titleTypographyProps={{ variant: 'h6' }}
					avatar={
						<Avatar sx={{ bgcolor: color }} aria-label="recipe">
							{plan?.profile?.name?.[0]}
						</Avatar>
					}
				/>
			)}
			<CardContent>
				<Typography variant="body2" color="textSecondary">
					{plan?.products && plan?.products.map((product: any) => product.name).join(', ')}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					{plan?.meal} oz. meal
				</Typography>
				<Typography variant="caption" color="textSecondary" textAlign={'right'}>
					{plan?.status}
				</Typography>
			</CardContent>
			{actions && (
				<CardActions>
					{actions.map(
						(
							{ label, size = 'small', variant = 'text', color = 'primary', link }: any,
							index: number
						) => (
							<Button
								key={`plan-action-${plan.id}-${index}`}
								size={size}
								component={NavLink}
								color={color}
								variant={variant}
								to={link}
							>
								{label}
							</Button>
						)
					)}
				</CardActions>
			)}
		</Card>
	)
}
